import React from "react";
import { MessageCircle } from "lucide-react";

export const WhatsAppFab = () => (
  <a
    href="https://wa.me/919798203741?text=Hi%20AASAN%20OPD"
    target="_blank" rel="noreferrer"
    data-testid="whatsapp-fab"
    className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white shadow-lg shadow-emerald-500/30 px-4 py-3 active:scale-95"
    style={{ transition: "background-color .2s, transform .1s" }}
  >
    <MessageCircle size={22}/>
    <span className="hidden sm:inline text-sm font-medium">WhatsApp</span>
  </a>
);
